import * as React from "react"
import { Box } from "@mui/material"

import { LinkIconBlock } from "@components"


export default function productURLColumn() {
    return {
        name: "productURL", label: "Product URL",
        options: {
            customBodyRowRenderLite: value => <Box display="flex" justifyContent="center">
                <LinkIconBlock url={value} variant="body2" sx={{ display: "inline-block" }}>
                    View Product
                </LinkIconBlock>
            </Box>
        }
    }
}